var map = {
	"./background.jpg": 354,
	"./cd-header.jpg": 355,
	"./footer.jpg": 356,
	"./goods-header.jpg": 357,
	"./logo.png": 350,
	"./menu-cd.png": 358,
	"./menu-goods.png": 359,
	"./menu-story.png": 360,
	"./menu-top.png": 361,
	"./story-header.jpg": 362,
	"./story-icon.png": 363,
	"./twitter.png": 351,
	"./youtube.png": 352
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 353;



//////////////////
// WEBPACK FOOTER
// ./src/images ^\.\/.*$
// module id = 353
// module chunks = 0